

































import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import { isMobile } from 'mobile-device-detect'
import CompleteDealButton from '@/components/modules/App/Profile/CompleteDealButton.vue'
import { DealStageEnum } from '@/requests/mainApi'
import { LifeState } from '@/views/App/Deal/store/interfaces'

interface Data {}

interface Methods {
  onHover: () => void
}

interface Computed {
  getBackgroundColor: string
  shouldShowButton: boolean
}

interface Props {
  lifeState: LifeState
  isSelected: boolean
}

export default Vue.extend({
  name: 'LifeLinePlate',
  components: {
    CompleteDealButton
  },
  props: {
    lifeState: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    currentStepIndex: {
      type: Number,
      required: true
    },
    lifeLineLength: {
      type: Number,
      required: true
    }
  },
  computed: {
    shouldShowButton () {
      return Boolean((this.lifeState.isPassed || this.lifeState.isCurrentStep) && this.lifeState.plateButtonStage)
    },
    isSelectedStep () {
      return this.isSelected
    },
    getBackgroundImage () {
      const path = this.isSelected || isMobile
        ? this.lifeState.backgroundAfterCompletion
        : this.lifeState.backgroundAfterCompletionMin ?? this.lifeState.backgroundAfterCompletion
      return this.lifeState.isPassed
        ? `url("${path}")`
        : 'none'
    },
    getBackgroundColor () {
      return this.lifeState.isCurrentStep
        ? 'var(--main-violet)'
        : this.lifeState.plateColor
    },
    getProgressLabel () {
      if (this.lifeState.isCurrentStep) {
        return this.$t('app.lifeLine.stageInfo', { num: this.lifeState.lifeLineIndex! + 1 })
      }
      return this.lifeState.lifeLineIndex! + 1
    },
    getIndicator () {
      return this.lifeState.isPassed
        ? '✔'
        : this.lifeState.lifeLineIndex! + 1
    },
    getColor () {
      return this.lifeState.isPassed
        ? '#ffffff'
        : this.getBackgroundColor
    },
    backgroundClasses () {
      let classes: string[] = []
      if (this.lifeState.isPassed) classes.push('life-line__background-passed')
      if (this.shouldShowButton) classes.push('life-line__background-details')
      if (this.isSelected) classes.push('life-line__background-selected')
      return classes
    },
    indicatorClasses () {
      let classes: string[] = []
      if (this.lifeState.isPassed) classes.push('life-line__indicator-passed')
      if (this.isSelected) classes.push('life-line__indicator-selected')
      return classes
    },
    getAllBackgrounds () {
      return `url(${this.lifeState.backgroundAfterCompletion}) url(${this.lifeState.backgroundAfterCompletionMin})`
    }
  },
  mounted () {
    this.$el.addEventListener('mouseover', this.onHover)
  },
  methods: {
    onHover () {
      this.$emit('hover', this.lifeState)
    }
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
